import { colors, font, spacing } from '@chegg-ui/theme'
import styled from 'styled-components'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

export const Container = styled.div`
  position: relative;
`

export const TextBox = styled.div`
  ${AspiraStack};
  font-weight: ${font.weight.bold};
  font-size: ${font.size.px16};
  padding: ${spacing.px12} ${spacing.px24};
  border: 1px solid ${colors.greyLight};
  box-shadow: 0 0 4px 0 rgba(34, 34, 34, 0.24);
  opacity: 1;
  background-color: ${colors.white};
  z-index: 1;
  text-align: center;
  line-height: 22px;
`

export const CenterContent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
`

export const AuthLink = styled.a`
  color: ${colors.link};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`

export const Children = styled.div`
  opacity: 0.1;
  pointer-events: none;
`
